import { useQuery } from "@tanstack/react-query";
import { getHelpArticleTreeByScope } from "../api/getHelpArticleTreeByScope";
import type { HelpScope } from "@fysaro/shared";
import { QUERY_KEYS } from "@/shared/api/query-keys";

interface HelpTreeParams {
  scope: HelpScope;
  language: string;
}

export const useGetHelpArticleTreeByScope = (
  params: HelpTreeParams,
  options?: { enabled?: boolean },
) =>
  useQuery({
    queryKey: [QUERY_KEYS.HELP_ARTICLES, "tree", params.scope, params.language],
    queryFn: () => getHelpArticleTreeByScope(params),
    enabled:
      (options?.enabled ?? true) && Boolean(params.scope) && Boolean(params.language),
  });
